var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"iconfont icon-container",class:_vm.iconClass,on:{"click":e => _vm.$emit('click', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }